<div class="" aria-hidden="true">
  <div >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Crear Lista de Materiales</h5>
        <button (click)="cerrar()" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <ngx-table [configuration]="configuration" [data]="data" [columns]="columns">
          <ng-template let-row>
            <td (click)="cerrar(row)" style="cursor: pointer;">
              {{row.ItemCode}}
            </td>
            <td (click)="cerrar(row)">

              {{row.U_IND_SWW}}
            </td>
            <td (click)="cerrar(row)">
              {{row.ItemName}}
            </td>

          </ng-template>
        </ngx-table>

      </div>

    </div>
  </div>
</div>
